module.exports = __webpack_public_path__ + "img/PC_google.efbcd3b3.png";